import {useState}  from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

function App(props) {

  var isOn = props.isOn;
  var actualWidth = props.actualWidth;
  var itemEdited = props.itemEdited;
  var aKey = props.aKey;
  var intermediatePath = props.intermediatePath;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var itemType = props.itemType;
  var setItemEdited = props.setItemEdited;

  var itemPath = itemEdited.path;

  const [isHover, setIsHover] = useState(false);

  var coverStyle = {};
  var dropText = null;
  var droppableClassName = 'droppableArea';
  if (isOn){
    if (itemType === 'screen'){
      dropText = 'Drop Panel Here';
    }else if (itemType === 'alert'){
      dropText = 'Drop Alert Here';
    }else if (itemType === 'containerMain'){
      dropText = 'Drop Container Here';
      droppableClassName += ' container';
    }else if (itemType === 'hflex'){
      dropText = 'Drop Row Here';
      droppableClassName += ' row';
    }else if (itemType === 'item'){
    }

    if (itemType === 'screen' || itemType === 'alert' || itemType === 'containerMain' || itemType === 'hfex' || itemType === 'item'){
      coverStyle = {width:actualWidth};    
    }
    if (isHover){
      coverStyle.backgroundColor = '#AAAAFF';
    }
  }else{
    coverStyle = {display:'none'};
  }

  function onDragOver(e){
    setIsHover(true);
    e.preventDefault();
  }

  function onDragLeave(e){
    setIsHover(false);
    e.preventDefault();
  }

  function onDrop(e){

    var setOfContainersPath = CoreFns.filterPathStopBefore(itemPath, itemPath.length - 1);
    var thisP =  itemPath[itemPath.length - 1];
    var changes = [{t:'r',w: setOfContainersPath, i:thisP}];
    var thisItem = CoreFns.goDownPath(currentList, itemPath);

    var parents = CoreFns.goDownPath(currentList, intermediatePath);

    var orderedKeys;
    if (itemType === 'screen'){
      orderedKeys = CoreFns.sortedKeyList(parents);
    }else{
      orderedKeys = ResponsiveFns.sortAListBasedOnOrd(parents);
    }

    var newItem = JSON.parse(JSON.stringify(thisItem));

    if (aKey){
      var havePassed = false;
      for (var i = 0; i < orderedKeys.length; i++){
        if (!havePassed){
          if (orderedKeys[i] === aKey){
            havePassed = true;
            if (itemType === 'screen'){
              newItem.ord = parents[orderedKeys[i]].ord;
            }else{
              newItem.s.ord.v = parents[orderedKeys[i]].s.ord.v;
            }
            changes.push({t:'w', w:intermediatePath.concat([thisP]), n:newItem});
            setItemEdited({t:itemEdited.t, path:intermediatePath.concat([thisP])})
          }
        }

        if (havePassed){
          var thisP2 = intermediatePath.concat([orderedKeys[i]]);
          if (thisP2.join(' ') === itemPath.join(' ')){
            break;
          }else{
            var thisOrd;
            if (itemType === 'screen'){
              if (i === orderedKeys.length - 1){
                thisOrd = parents[orderedKeys[i]].ord + 1;
              }else{
                thisOrd = parents[orderedKeys[i+1]].ord;
              }
              changes.push({t:'w', w:intermediatePath.concat([orderedKeys[i], 'ord']), n:thisOrd});            

            }else{
              if (i === orderedKeys.length - 1){
                thisOrd = parents[orderedKeys[i]].s.ord.v + 1;
              }else{
                thisOrd = parents[orderedKeys[i+1]].s.ord.v;
              }
              changes.push({t:'w', w:intermediatePath.concat([orderedKeys[i], 's', 'ord', 'v']), n:thisOrd});

            }
          }

        }
      }      
    }else{
      if (orderedKeys.length > 0){
        var lastCurrent = parents[orderedKeys[orderedKeys.length - 1]];
        if (itemType === 'screen'){
          newItem.ord = lastCurrent.ord + 1;
        }else{
          newItem.s.ord.v = lastCurrent.s.ord.v + 1;
        }

        changes.push({t:'w', w:intermediatePath.concat([thisP]), n:newItem});
        setItemEdited({t:itemEdited.t, path:intermediatePath.concat([thisP])})
      }
    }

    organicChanges(changes);

  }

  return <div className={droppableClassName} style={coverStyle} onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop}>{dropText}</div>

//  
}

export default App;
